<template>
    <div class="hot">
        <div class="title">推荐产品</div>

        <div class="product-list">
            <router-link
                class="item"
                v-for="(val, index) in productList"
                :key="index"
                :to="'/product-detail/' + val.productId"
            >
                <div class="img">
                    <img :src="val.structureImage"  @load = "imgLoad"/>
                </div>
                <div class="name">{{ val.productName }}</div>
                <div class="price">
                    <span class="fontpriceitem">¥{{ val.originalMoney }}</span>
                    <span class="priceitem">¥{{ val.discountMoney }}</span>
                </div>
            </router-link>
        </div>

        <div class="coa">
            <div class="coa-t">COA查询：</div>
            <el-form ref="ruleForm" status-icon :model="ruleForm" label-width="0px">
                <p>请输入批号：</p>
                <el-form-item label prop="batchNo" style = "margin-bottom:10px">
                    <el-input v-model="ruleForm.batchNo" placeholder="请输入批号" size="small"></el-input>
                </el-form-item>
                <p>请输入货号：</p>
                <el-form-item label prop="specsNo" style = "margin-bottom:10px">
                    <el-input v-model="ruleForm.specsNo" placeholder="请输入货号" size="small"></el-input>
                </el-form-item>
            </el-form>
            <button class="btn" @click="onSubmitValidate">查询</button>
        </div>
    </div>
</template>

<script>
import * as apis from '../../fetch/common';

export default {
    name: 'Hot',
    data() {
        return {
            ruleForm: {
                batchNo: '',
                specsNo: '',
            },
            rules: {
                batchNo: [{ required: true, message: '请输入批号', trigger: 'blur' }],
                specsNo: [{ required: true, message: '请输入货号', trigger: 'blur' }],
            },
            productList: [],
        };
    },
    methods: {
        onSubmitValidate() {
            this.$refs['ruleForm'].validate(valid => {
                if (valid) {
                    this.onSubmit();
                } else {
                    return false;
                }
            });
        },
        onSubmit() {
            const params = { ...this.ruleForm };
            apis.getCoa(params).then(res => {
                window.open(res);
            });
        },
        getProducts() {
            apis.getFeaturedList(2, 3).then(res => {
                this.productList = res;
            });
        },
        imgLoad(self){
           var _img = self.target;
           var _imgWidth = _img.naturalWidth;
           var _imgHeight = _img.naturalHeight;
            if(_imgHeight > 103 || _imgWidth > 103){
                if(_imgHeight-_imgWidth>=0){
                    _img.height = 103;
                    _img.width = 103/_imgHeight*_imgWidth;
                    //$(obj).css("height","161");
                    //$(obj).css("width",161/_imgHeight*_imgWidth);
                }else{
                    _img.width = 103;
                    var _result = 103/_imgWidth*_imgHeight;
                    _img.height = _result;

                    console.log( _img.width)
                     console.log( _img.height)
                    //$(obj).css("width","161");
                    //$(obj).css("height",161/_imgWidth*_imgHeight);
                }
            }   
            var height = _img.height/2;
            var width = _img.width/2;

            _img.style.marginTop = -height + "px";
            _img.style.marginLeft = -width + "px";
           // $(obj).css("margin-top",-height);
            //$(obj).css("margin-left",-width);           

        }  
    },
    mounted() {
        this.getProducts();
    },
};
</script>

<style lang="less" scoped>
.hot {
    width: 240px;
    .title {
        width: 240px;
        height: 50px;
        background-color: #3c9539;
        font-size: 16px;
        color: #fff;
        line-height: 50px;
        text-align: center;
    }

    .product-list {
        .item {
            width: 240px;
            height: 200px;
            background: #ffffff;
            margin-top: 20px;
            border-radius: 10px;
            display: block;
            color: #333;
            overflow: hidden;
            .img {
                height: 134px;
                border-bottom: 1px dashed #eeeeee;
                padding: 15px 68px;
                position:relative;
                img {
                   position:absolute;
                   top:50%;
                   left:50%;
                }
            }
            .name {
                height: 32px;
                line-height: 32px;
                padding: 0 15px;
                font-size: 14px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;                
            }

            .price {
                padding: 0 15px;
                .fontpriceitem {
                    text-decoration: line-through;
                    font-size: 14px;
                    color: rgba(0, 0, 0, 0.4);
                }
                .priceitem {
                    color: #ff9236;
                    float: right;
                }
            }
        }
    }

    .coa {
        background-color: #ffffff;
        box-shadow: 0px 0px 10px 0px rgba(216, 216, 216, 0.5);
        border-radius: 10px;
        padding: 18px 15px;
        margin-top: 20px;
        .coa-t {
            font-size: 14px;
        }
        p {
            margin: 7px 0;
            font-size: 12px;
        }
        .btn {
            width: 100%;
            line-height: 40px;
            height: 40px;
            background-color: #3c9539;
            border-radius: 25px;
            font-size: 14px;
            color: #ffffff;
            outline: none;
        }
    }
}
</style>
